import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'vx-ui-components';
import styles from './styles.css';

class UserBox extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false };

    this.updateValue = this.updateValue.bind(this);
  }

  updateValue() {
    this.setState({ open: !this.state.open });
  }

  render() {
    const { userData, menuListData } = this.props;
  
    const logout = menuListData.filter(item => item.label === "Logout")[0];

    let content = (<div></div>);
    if (userData.api_key !== '') {
      content = (
        <p 
          key="username"
          className={styles.userName}
          onClick={menuListData.filter(menuItem => menuItem.label === 'Account')[0].action}
        >
          {`${userData.username}`}
        </p>
      );
    } else {
      content = (
        <p>
          Please login
        </p>
      );
    }

    return (
      <div className={styles.userBox}>
      {
        menuListData.map((menuItem, i) => {

          const page = window.location.pathname.slice(1);
          const label = menuItem.label.toLowerCase();

          if(menuItem.label !== "Logout" && menuItem.label !== "Account") {
            return (
              <div 
                title={menuItem.label}
                className={styles.button}
                onClick={menuItem.action}
                key={i}
                style={page === label ? { backgroundColor: '#e6e6e6'} : undefined}
              ><Icon stroke="#a9a9a9" name={menuItem.icon} />
              </div>
            )
          } else if (menuItem.label === "Account") {
            return (
              <div
                title={menuItem.label}
                className={styles.button_account}
                onClick={menuItem.action}
                key={i}
                style={page === label ? { backgroundColor: '#e6e6e6'} : undefined}
              >
                <Icon stroke="#68689e" name={menuItem.icon} />
              </div>
            )
          }
          return false;
        })
      } 
      <span >
        <div className={styles.userLogged}>
          
          {content}
          {
            <span title={logout.label} className={styles.logout} onClick={logout.action}>{logout.label}</span>
          }
        </div>

      </span>
      </div>
    );
  }
}

UserBox.propTypes = {
  userData: PropTypes.object.isRequired,
  menuListData: PropTypes.array.isRequired,
};

export default UserBox;



// WEBPACK FOOTER //
// ./src/components/UserBox/index.js